import rooms from './rooms';
import create from './create';
import remove from './delete';
import invites from './invites';
import join from './join';
import leave from './leave';
import update from './update';
import view from './view';
import kick from './kick'
import makeCohost from './makeCohost';

export default {
	// namespaced: true,
	modules: {
		rooms, create, remove, invites, join, leave, update, view, kick, makeCohost
	}
}
